import LocalStorys from './localStorys'

export default LocalStorys